import React from "react";
import { Navigate } from "react-router-dom";

/** Legacy `/about_us` → Company page */
const AboutUs = () => <Navigate to="/about_us/company" replace />;

export default AboutUs;
